module.exports = __webpack_public_path__ + "static/media/cancel.4952bc09.svg";